import React from 'react';
import { ASSETS, SAFE_FUN_ITEMS } from '../mock';

const SafeFun = () => {
  return (
    <section className="relative bg-white py-24 px-6 md:px-12 overflow-hidden">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-16">
          <div className="flex items-center justify-center gap-2 mb-4">
            <img src={ASSETS.smallHeart} alt="" className="w-5 h-5" />
            <p className="text-fnl-pink font-semibold text-sm tracking-[0.2em] uppercase">Safe & Fun</p>
            <img src={ASSETS.smallHeart} alt="" className="w-5 h-5" />
          </div>
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            Flirt and stay anonymous
          </h2>
          <p className="text-gray-600 text-lg max-w-2xl mx-auto">
            Our users enjoy the pleasure of discretion. User trust and respect is a vital part of our community ethos.
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-6 md:gap-8">
          {SAFE_FUN_ITEMS.map((item) => (
            <div
              key={item.title}
              className="relative bg-gradient-to-br from-pink-50 to-purple-50 rounded-3xl p-8 card-hover border border-pink-100"
            >
              <div className="w-20 h-20 rounded-2xl bg-white shadow-md flex items-center justify-center mb-6">
                <img src={item.icon} alt="" className="w-12 h-12 object-contain" />
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-3">{item.title}</h3>
              <p className="text-gray-600 text-sm leading-relaxed">{item.text}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default SafeFun;
